import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { testimonials } from '../../data/testimonials';
import { SectionHeading } from '../SectionHeading';
import { StarRating } from '../StarRating';
export function TestimonialsSection() {
  const {
    t
  } = useLanguage();
  const [featured, ...rest] = testimonials;
  return <section className="bg-mist" aria-labelledby="testimonials-heading" data-id="element-204" data-mp="2gfbpmkwdktr7">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24" data-id="element-205" data-mp="2gheqy12za9b8">
        <SectionHeading id="testimonials-heading" eyebrow={t({
        en: 'Customer reviews',
        es: 'Opiniones de clientes'
      })} title={t({
        en: 'What Dallas homeowners say about the work',
        es: 'Lo que dicen los dueños de casa en Dallas'
      })} data-id="element-206" data-mp="2lddanbdd335b" />

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.15fr_1fr]" data-id="element-207" data-mp="2zdebwrxjgclb">
          <figure className="flex flex-col justify-between rounded-xl bg-navy p-8 sm:p-10" data-id="element-208" data-mp="345fvz00y77lw">
            <div data-id="element-209" data-mp="15kiyog2usuj9">
              <QuoteIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-210" data-mp="15k0tgty7r5z7" />
              <blockquote className="mt-6 font-display text-2xl leading-snug text-white sm:text-[1.75rem]" data-id="element-211" data-mp="10lzeol7tlstj">
                “{t(featured.quote)}”
              </blockquote>
            </div>
            <figcaption className="mt-8 flex items-center gap-4 border-t border-white/10 pt-6" data-id="element-212" data-mp="1ajvo98l40fpj">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold font-semibold text-navy-deep" data-id="element-213" data-mp="1oba4j7nmu2sw">
                {featured.initials}
              </span>
              <span data-id="element-214" data-mp="1kbrpgsihslxz">
                <span className="block font-semibold text-white" data-id="element-215" data-mp="1y97ubzl547nm">{featured.name}</span>
                <span className="block text-sm text-navy-100/75" data-id="element-216" data-mp="1tadd322tmr5m">
                  {t(featured.location)} · {t(featured.service)}
                </span>
              </span>
              <span className="ml-auto" data-id="element-217" data-mp="3vozwymep56j">
                <StarRating label={t({
                en: '5 out of 5',
                es: '5 de 5'
              })} data-id="element-218" data-mp="3v1zymo3y1tup" />
              </span>
            </figcaption>
          </figure>

          <ul className="grid gap-6 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2" data-id="element-219" data-mp="1yzwqg08076dh">
            {rest.slice(0, 4).map(testimonial => <li key={testimonial.name} data-id="element-220" data-mp="23zj3o9nu0mma">
                <figure className="flex h-full flex-col rounded-xl border border-navy/10 bg-white p-6" data-id="element-221" data-mp="27y8fvyx4vy4c">
                  <StarRating label={t({
                en: '5 out of 5',
                es: '5 de 5'
              })} data-id="element-222" data-mp="2czfrya6b7jgt" />
                  <blockquote className="mt-4 text-[0.95rem] leading-relaxed text-ink/80" data-id="element-223" data-mp="2hxzdi9gzqt8n">
                    “{t(testimonial.quote)}”
                  </blockquote>
                  <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-224" data-mp="2mu7nz9k8ty9h">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-navy-100 text-sm font-semibold text-navy" data-id="element-225" data-mp="2ro2ccqasn1ew">
                      {testimonial.initials}
                    </span>
                    <span data-id="element-226" data-mp="30lultdtu3eud">
                      <span className="block text-sm font-semibold text-navy" data-id="element-227" data-mp="35ms9u71iz33s">
                        {testimonial.name}
                      </span>
                      <span className="block text-xs text-ink/60" data-id="element-228" data-mp="3fsjr4tkz9fvj">
                        {t(testimonial.location)} · {t(testimonial.service)}
                      </span>
                    </span>
                  </figcaption>
                </figure>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}